import PropTypes from 'prop-types'

import { sanitizeHTML } from '@aytm/lib/common/html'

// The narrative is the engine's sentences around the author's free-text price affixes. It keeps only the
// markup the engine writes -- bold prices, line breaks and the contact link -- so anything an author typed
// into the estimated price stays inert.
// `span` stays allowed: the sanitiser turns every other tag into one, and a span it may not keep it would
// rewrite forever.
const NARRATIVE_MARKUP = {
  allowedTags: ['b', 'br', 'a', 'span'],
  allowedAttributes: ['href', 'target'],
  includeDefault: false
}

const parseValue = value => {
  if (typeof value === 'string') {
    return value
  }

  if (Array.isArray(value)) {
    return value?.[0]
  }

  return ''
}

const Text = ({ value, className = '' }) => {
  const parsedValue = parseValue(value)

  if (!parsedValue) {
    return null
  }

  return <div className={className} dangerouslySetInnerHTML={{ __html: sanitizeHTML(parsedValue, NARRATIVE_MARKUP) }} />
}

// Same shape, no markup sink: a range label is a value, not authored copy, so it renders as a
// text child and any tags in it stay inert.
export const PlainText = ({ value, className = '' }) => {
  const parsedValue = parseValue(value)

  if (!parsedValue) {
    return null
  }

  return <div className={className}>{parsedValue}</div>
}

Text.propTypes = {
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
}

PlainText.propTypes = Text.propTypes

export default Text
